import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-spinners-example',
  templateUrl: './spinners.component.html',
})
export class KitBootstrapSpinnersExampleComponent {}
